<template>
	<!-- 对话框 -->
	<el-dialog :title="config.title" :visible.sync="visible" custom-class="hb-dialog">
		<div style="display: flex;flex-direction: row;">
			<div style="display: flex;flex-direction: column;">
				<el-form
					:class="config.formItems.length > 3 ? 'hb-dialog-form' : ''"
					:ref="thisRef"
					:model="formData"
					:rules="rules"
					:label-width="config.labelWidth ? (config.labelWidth / 192) + 'rem' : (100/192) + 'rem'"
					status-icon
				>
					<template v-for="(item, index) in config.formItems">
						<el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'input'">
							<el-input class="hb-dialog-input" v-model="formData[item.prop]" :placeholder="item.placeholder"></el-input>
						</el-form-item>
						<el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'textarea'">
							<el-input class="hb-dialog-input" type="textarea" v-model="formData[item.prop]" :placeholder="item.placeholder"></el-input>
						</el-form-item>
						<el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'select'">
							<el-select v-model="formData[item.prop]" :placeholder="item.placeholder ? item.placeholder : '请选择'" class="hb-dialog-input">
								<template v-for="(selectItem, selectIndex) in item.items">
									<el-option
										:label="item.labelkey ? selectItem[item.labelkey] : selectItem.name"
										:value="item.valuekey ? selectItem[item.valuekey] : selectItem.value"
										:key="selectIndex"
									></el-option>
								</template>
							</el-select>
						</el-form-item>
						<el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'cascader'">
							<el-cascader
								class="hb-dialog-input"
								v-model="formData[item.prop]"
								:placeholder="item.placeholder ? item.placeholder : '请选择'"
								:options="cascaderFormat(item.items, item.labelkey, item.valuekey, item.linkword)"
							></el-cascader>
						</el-form-item>
					</template>
				</el-form>

				<span slot="footer" class="dialog-footer">
					<slot></slot>
					<el-button class="dialog-footer-btn" type="primary" @click="handle()" :disabled="disabled" v-if="btns.submitBtn" style="background-color: #084FF7;">
						{{ btns.submitTitle ? btns.submitTitle : '确定' }}
					</el-button>
					<el-button class="dialog-footer-btn" type="primary" @click="visible = false" :disabled="disabled" v-if="btns.closeBtn" plain>
						{{ btns.closeTitle ? btns.closeTitle : '取消' }}
					</el-button>
				</span>
			</div>
			<div class="hb-dialog-bg" :style="'background-image: url('+ (config.background?config.background:'/static/img/dialogadd.jpg') +');'" v-if="config.formItems.length < 4"></div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			thisRef: this._uid + 'dialog',
			formData: {},
			rules: {},
			disabled: false,
			visible: false,
			btns: { closeBtn: true, submitBtn: true, closeTitle: '取消', submitTitle: '确定' }
		}
	},
	props: {
		config: {
			Type: Object,
			default: '请选择'
		},
		dialogSubmit: {
			Type: Function,
			default: function() {
				console.log('error:未绑定回调函数dialogSubmit')
			}
			//普通选择器selector 多列选择器multiSelector
		},
		dialogClose: {
			Type: Function
		},
		selectChange: {
			Type: Function,
			default: ''
		},
		singleFields: {
			Type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		}
	},
	created() {},
	watch: {
		visible: function(val) {
			let that = this
			if (!val) {
				// console.log('++++++++++++++++++++++',that.$refs[that.config.ref]);
				that.$refs[that.thisRef].resetFields()
				that.disabled = false
			} else {
				that.initData()
				// that.$refs[that.thisRef].clearValidate()
			}
		},
		config: function() {
			this.initData()
		}
	},
	methods: {
		//联机选择器初始化数据
		cascaderFormat(data, lkey, vkey, linkword) {
			let len = data.length
			if (!lkey.length) {
				let lk = []
				for (let i = 0; i < data.length; i++) {
					if (lkey) {
						lk.push(lkey)
					} else {
						lk.push('desc')
					}
				}
				lkey = lk
			}
			if (!vkey.length) {
				let vk = []
				for (let i = 0; i < data.length; i++) {
					if (vkey) {
						vk.push(vkey)
					} else {
						vk.push('desc')
					}
				}
				vkey = vk
			}
			if (!linkword || !linkword.length) {
				linkword = []
				for (let i = 0; i < data.length; i++) {
					linkword.push(['id', 'parentId'])
				}
			}
			// let rdata = []
			// for (let i = 0; i < data[0].length; i++) {
			// 	let item = {}
			// 	item[lkey] =
			// 	rdata.push()
			// }
			// console.log('cascaderFormat----key', lkey)
			// console.log('cascaderFormat----key2', vkey)
			// console.log('cascaderFormat----Linkword', linkword)
			// return options
		},
		//初始化
		init() {
			if (this.config.btns) {
				if (this.config.btns.closeBtn != undefined) {
					if (this.config.btns.closeBtn == false || this.config.btns.closeBtn == 'false') {
						this.btns.closeBtn = false
					}
				}
				if (this.config.btns.submitBtn != undefined) {
					if (this.config.btns.submitBtn == false || this.config.btns.submitBtn == 'false') {
						this.btns.submitBtn = false
					}
				}
				if (this.config.btns.closeTitle != undefined) {
					this.btns.closeTitle = this.config.btns.closeTitle
				}
				if (this.config.btns.submitTitle != undefined) {
					this.btns.submitTitle = this.config.btns.submitTitle
				}
			}
		},
		handle() {
			let that = this
			this.disabled = true
			this.$refs[this.thisRef].validate(valid => {
				if (valid) {
					// console.log('表单验证成功', that.config)
					// console.log('that.formData', that.formData)
					let adata = JSON.parse(JSON.stringify(that.formData))
					if (that.config.api) {
						that.submit(adata)
					} else {
						that.dialogSubmit(adata)
					}
				} else {
					this.disabled = false
					return
				}
			})
		},
		createRules() {
			let items = this.config.formItems
			let rs = this.config.rules
			let reg = /^[a-zA-z]+-[0-9]+$/
			for (let i = 0; i < items.length; i++) {
				let r = rs[items[i].prop]
				this.rules[items[i].prop] = []
				if (r == undefined) {
					break
				}
				for (let ii = 0; ii < r.length; ii++) {
					if (r[ii] == 'required') {
						this.rules[items[i].prop].push({
							required: true,
							message: items[i].type == 'input' ? '请填写' : '请选择' + items[i].label,
							trigger: 'change'
						})
					}
					if (r[ii] == 'number') {
						this.rules[items[i].prop].push({
							pattern: /^[0-9]+$/,
							message: '请填写数字值',
							trigger: 'change'
						})
					}
					if (r[ii] == 'phone') {
						this.rules[items[i].prop].push({
							pattern: /^1[3456789]\d{9}$ /,
							message: '请填写正确手机号码',
							trigger: 'change'
						})
					}
					if (r[ii] == 'arrayRequired') {
						this.rules[items[i].prop].push({
							type: 'array',
							required: true,
							message: '请选择' + items[i].label,
							trigger: 'change'
						})
					}
					if (reg.test(r[ii])) {
						let arr = r[ii].split('-')
						if (arr[0] == 'max') {
							this.rules[items[i].prop].push({
								max: parseInt(arr[1]),
								message: '最大长度' + arr[1] + '个字符',
								trigger: 'change'
							})
						} else if (arr[0] == 'min') {
							this.rules[items[i].prop].push({
								min: parseInt(arr[1]),
								message: '最小长度' + arr[1] + '个字符',
								trigger: 'change'
							})
						}
					}
				}
			}
			// console.log('验证规则', this.rules)
		},
		initData() {
			if (this.config.formData != undefined) {
				this.formData = JSON.parse(JSON.stringify(this.config.formData))
			}
		},
		dialogShow() {
			this.visible = true
		},
		dialogHide() {
			this.visible = false
		},
		getFormData() {
			return this.formData
		},
		submit(data) {
			let rdata = {}
			let idata = this.config.formData
			let isChange = false
			for (let key in data) {
				if (key == 'id') {
					rdata[key] = data[key]
				}
				for (let key2 in idata) {
					if (key == key2 && data[key] != idata[key2]) {
						rdata[key] = data[key]
						isChange = true
					}
				}
			}
			if (!isChange) {
				this.$message({
					message: '数据无修改',
					duration: 2000,
					type: 'warning'
				})
				this.disabled = false
				return
			}

			let that = this
			this.$API[this.config.api](rdata).then(
				res => {
					that.dialogHide()
					this.disabled = false
					this.$emit('succHandler', this.config.type)
				},
				err => {
					console.log('dialog提交失败：', err)
					this.disabled = false
				}
			)
		}
	},
	mounted() {
		this.init()
		this.createRules()
		this.initData()
	}
}
</script>

<style scoped>
.dialog-footer-btn {
	width: 130px;
	/* width: 200px; */
	height: 36px;
	/* height: 42px; */
	padding: 10px;
}
.dialog-footer{
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	/* margin-bottom: 20px; */
}
.del-dialog-cnt {
	font-size: 16px;
	text-align: center;
}
.hb-dialog {
	padding: 50px !important;
}
.hb-dialog-input {
	width: 350px;
}
>>> .el-dialog__title {
	padding-left: 20px;
	border-left: 4px solid #084ff7;
}
>>> .el-form-item__label {
	/* font-size: 18px; */
}
>>> .el-textarea__inner {
	font-size: 14;
	color: #606266;
	font-weight: 400;
	font-family: Arial;
}
.hb-dialog-form {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.hb-dialog-bg {
	background-repeat: no-repeat;
	background-position: right;
	background-size: auto 100%;
	background-position: center;
	min-height: 250px;
	flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/hbDialog-copy.vue